import type { ReactElement } from "react";

import { Spinner } from "../atoms/Spinner";
import styles from "./LoadingState.module.css";

export interface LoadingStateProps {
  readonly label: string;
}

/**
 * What a container renders while its query is pending.
 *
 * It is a component and not an inline `if` because F-UIX-010 asks for exactly
 * that: three named states every screen renders the same way. It shows the
 * spinner and its label and NOTHING else — a partially drawn list under a
 * spinner reads as data that is already there.
 */
export function LoadingState({ label }: LoadingStateProps): ReactElement {
  return (
    <div className={styles.state}>
      <Spinner label={label} />
    </div>
  );
}
